import { getDispatch } from '../get-dispatch';
import { DispatchAction } from '../utility/dispatch-action';
import { UserActions, USER_STATE_NAMESPACE } from './user.module.types';

export const dispatchUserAction: DispatchAction<UserActions> =
  getDispatch(USER_STATE_NAMESPACE);
